import React from 'react';
import AssetForm from '../Asset/AssetForm.react';
import EventActions from '../../actions/EventActionCreator';


const EventAssetForm = React.createClass({

    render: function() {
        const returnUrl = '/dashboard/event/' + this.props.routeParams.eventId;
        
        return (
            <AssetForm title="New Event Asset" 
                returnUrl={returnUrl}
                onSubmit={this.onSubmitForm}
            />
        )
    },
    onSubmitForm: function(asset) {
        return EventActions.saveAsset(this.props.routeParams.eventId, asset);
    }
});

export default EventAssetForm;
